import { Check } from 'lucide-react'
import { SonCta } from '../components/cta'
import { Reveal, Stagger, StaggerItem } from '../components/hareket'
import { Mockup } from '../components/mockup'
import { Baslik, Kart, SayfaUstu, Section } from '../components/ui'
import { useHead } from '../lib/head'

export function Gecis() {
  useHead(
    {
      title: 'Geçiş ve veri taşıma',
      description:
        'Excel ve CSV ile üye ve aidat aktarımı ücretsiz; eski yazılımın veritabanından taşıma teklife bağlı. Eski panel salt okunur kalır, kapanış birlikte planlanır.',
    },
    '/gecis',
  )
  const adimlar = [
    {
      b: 'Kapsam görüşmesi',
      m: 'Hangi veri nerede: üye, aidat, ödeme geçmişi, belgeler, site içeriği. Yarım saatlik görüşme; kapsam yazılı çıkar.',
    },
    {
      b: 'Ön izleme',
      m: 'Dosyanızı yüklersiniz; sistem satır satır kontrol eder, hiçbir şey yazmaz. Hatalı satırlar sebebiyle listelenir.',
    },
    {
      b: 'Deneme aktarımı',
      m: 'Deneme ortamına aktarılır; siz kontrol edersiniz. Beğenmezseniz silinir ve baştan yapılır.',
    },
    {
      b: 'Kesin aktarım ve paralel dönem',
      m: 'Gerçek ortama aktarım. Eski sistem bir süre salt okunur kalır; iki yerde karşılaştırırsınız.',
    },
    {
      b: 'Eski sistemin kapanışı',
      m: 'Karşılaştırma bitince eski sistem kapatılır. Verinin kişisel veri kısmı saklama süresine göre imha edilir.',
    },
  ]
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
            <Reveal>
              <Baslik
                seviye="h1"
                eyebrow="Geçiş ve veri taşıma"
                baslik="Veriniz kaybolmadan, işiniz durmadan"
                metin="Geçişin önündeki en büyük engel veridir. Bu yüzden standart aktarım ücretsizdir ve ön izlemeyle çalışır: hiçbir satır siz görmeden yazılmaz. Eski yazılımın veritabanından taşıma ayrı bir iştir; kapsamı birlikte belirler, teklif veririz."
              />
            </Reveal>
            <Reveal delay={0.1} y={24}>
              <Mockup anahtar="uyeler" />
            </Reveal>
          </div>
        </Section>
      </SayfaUstu>
      <Section className="bg-surface/60">
        <div className="grid gap-4 md:grid-cols-2">
          <Reveal>
            <Kart className="h-full p-6">
              <p className="text-lg font-semibold text-ink">Standart aktarım</p>
              <p className="data mt-1 text-2xl font-semibold text-brand">Ücretsiz</p>
              <ul className="mt-4 space-y-2 text-sm text-ink">
                {[
                  'Excel ya da CSV üye listesi',
                  'Aidat borç ve ödeme geçmişi',
                  'Üye numaraları ve özel alanlar korunur',
                  'Ön izleme, satır satır hata raporu',
                  'İstediğiniz kadar tekrar',
                ].map((m) => (
                  <li key={m} className="flex items-start gap-2">
                    <Check className="mt-0.5 size-4 shrink-0 text-brand" aria-hidden />
                    {m}
                  </li>
                ))}
              </ul>
            </Kart>
          </Reveal>
          <Reveal delay={0.1}>
            <Kart className="h-full p-6">
              <p className="text-lg font-semibold text-ink">Özel veri taşıma</p>
              <p className="data mt-1 text-2xl font-semibold text-ink">Teklife bağlı</p>
              <ul className="mt-4 space-y-2 text-sm text-ink">
                {[
                  'Eski yazılımın veritabanından doğrudan',
                  'Ödeme geçmişi, belgeler, site içeriği, etkinlik ve kurs kayıtları',
                  'Şema eşleme dokümanı size verilir',
                  'Paralel dönem ve karşılaştırma raporu',
                  'Eski sistemin kapanış planı',
                ].map((m) => (
                  <li key={m} className="flex items-start gap-2">
                    <Check className="mt-0.5 size-4 shrink-0 text-brand" aria-hidden />
                    {m}
                  </li>
                ))}
              </ul>
            </Kart>
          </Reveal>
        </div>
      </Section>
      <Section>
        <Reveal>
          <Baslik eyebrow="Adımlar" baslik="Özel taşıma nasıl ilerler" />
        </Reveal>
        <Stagger className="mt-10 grid gap-4 md:grid-cols-5">
          {adimlar.map((a, i) => (
            <StaggerItem key={a.b} className="h-full">
              <div className="h-full rounded-[var(--radius-panel)] bg-surface p-5 ring-soft">
                <span className="data text-xs font-semibold text-brand">0{i + 1}</span>
                <p className="mt-2 font-semibold text-ink">{a.b}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-2">{a.m}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>
      <SonCta
        baslik="Excel dosyanızla gelin."
        metin="Kapsam görüşmesi yarım saat sürer; hangi verinin nereye gideceği yazılı çıkar. Deneme aktarımını beğenmezseniz silinir."
      />
    </>
  )
}
